(function () {
    "use strict";

    /**
     * Gets a slice from an array starting from the index provided in the start argument
     * [1, 2, 3, 4, ..., n] | range:4 results in [5, 6, ..., n]
     */
    angular.module("app").filter("startFrom", Filter);

    function Filter() {
        return function (input, start) {
            start = +start;
            return input.slice(start);
        };
    }
})();
